import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  predominant_aif_type: {
    name: 'Predominant AIF type',
    order: 34,
    letter: 'A'
  },
  hft_transaction_number: {
    name: 'The total number of transactions carried out using a high frequency algorithmic trading technique',
    order: 35,
    letter: 'A'
  },
  hft_buy_sell_market_value: {
    name: 'The market value of buys and sells over the reporting period corresponding to the HFT transactions above',
    order: 36,
    letter: 'A'
  }
};

export function InvestmentStrategies({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.INVESTMENT_STRATEGIES,
    onChangeFund,
    schema: schema.INVESTMENT_STRATEGIES,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTMENT_STRATEGIES?.field_names || [],
    funds,
    isMultiFunds,
    tableName: 'INVESTMENT_STRATEGIES',
    columnLables
  });

  return (
    <Table
      id="fca-reporttables-investment-strategies-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
